import { addTrackingParams } from '~marketing/utils/add-tracking-params';

export enum ExtensionSupportedBrowser {
  CHROME = 'chrome',
  EDGE = 'edge',
  FIREFOX = 'firefox',
  BRAVE = 'brave',
  VIVALDI = 'vivaldi',
}

export const EXTENSION_SUPPORTED_BROWSERS: Record<
  ExtensionSupportedBrowser,
  {
    name: string;
    shortName: string;
    storeName: string;
    href: string;
    icon: string;
  }
> = {
  [ExtensionSupportedBrowser.CHROME]: {
    name: 'Google Chrome',
    shortName: 'Chrome',
    storeName: 'Chrome Web Store',
    icon: '/images/browser-icons/browser-icon-chrome.png',
    href: addTrackingParams(
      'https://chromewebstore.google.com/detail/deancpcgkpbklcglmcolggjmmpfplipc',
    ),
  },
  [ExtensionSupportedBrowser.EDGE]: {
    name: 'Microsoft Edge',
    shortName: 'Edge',
    storeName: 'Microsoft Edge Add-ons',
    icon: '/images/browser-icons/browser-icon-edge.png',
    href: addTrackingParams(
      'https://microsoftedge.microsoft.com/addons/detail/fflloknmheilgfjfgkojikmbflmpklmm',
    ),
  },
  [ExtensionSupportedBrowser.FIREFOX]: {
    name: 'Mozilla Firefox',
    shortName: 'Firefox',
    storeName: 'Firefox Browser Add-ons',
    icon: '/images/browser-icons/browser-icon-firefox.png',
    href: addTrackingParams(
      'https://addons.mozilla.org/firefox/addon/atlas-speed-dial-new-tab/',
    ),
  },
  [ExtensionSupportedBrowser.BRAVE]: {
    name: 'Brave',
    shortName: 'Brave',
    storeName: 'Chrome Web Store',
    icon: '/images/browser-icons/browser-icon-brave.png',
    href: addTrackingParams(
      'https://chromewebstore.google.com/detail/deancpcgkpbklcglmcolggjmmpfplipc',
    ),
  },
  [ExtensionSupportedBrowser.VIVALDI]: {
    name: 'Vivaldi',
    shortName: 'Vivaldi',
    storeName: 'Chrome Web Store',
    icon: '/images/browser-icons/browser-icon-vivaldi.png',
    href: addTrackingParams(
      'https://chromewebstore.google.com/detail/deancpcgkpbklcglmcolggjmmpfplipc',
    ),
  },
};
